export const createTeamAccordionItems = [
    {
      header: "What are the recommendations for Team profile & cover image?",
      content: "We usually recommend to use a team logo for team's profile picture and use teams group picture in team's jersey as a background. This will ensure to have a detailed teams theme for team members.",
    },

    {
        header: "Why do we need to provide location details of team?",
        content: "We highly recommend to provide actual location of teams operation. This will ensure to provide you personalised experience for related sports in your location. Our current as well as features are committed to enhance personalised experience for sports community. ",
      },

      {
        header: `What is "About me" section after team's details? `,
        content: `This section is to update a profile of a person who is creating team. This profile of user will be displayed to all team members joining this team. Data updated in profile is downloadable for quick analysis and for team and event management.`,
      },

      {
        header: `How shall I invite team members to join team?`,
        content: `For every team, a unique hyperlink will be created. The related hyperlink can be shared by clicking on the Invite Team icon of team's tile. Once you click on the Invite Team button, app will prompt you to share this link on various communication platform such as WhatsApp, WeChat, Facebook etc...
        
        Users will click on the link and will prompt to download the application (if they do not have one) or will be redirected to team's page to Accept or decline the invitation. Users can forward this link to other members and invite team to join a team.
        `,
      },

      {
        header: `How many Admins can be assigned to a team?`,
        content: `A team creator will be defaulted as a team admin. Team Admin, can mark the team members as Admin by selecting an Admin icon in front of the member's name. The normal member will immediately be converted into an Admin for a team. Team admin will have privileged rights to be selective for team members in events, add new members in team and many more future features.`,
      },

      {
        header: `What is a pending status in front of a team member?`,
        content: `Team admins can directly add team member into team by filling up related form within team. It is important to capture a right email address through which team member is going to login to SportsNerve platform. Once admin add team member to team, an invite will be sent to member to accept this invitation. The pending status will be reflected in team, until invited member accepts the invite. once invited member accepts the invite, the pending status will no longer be displayed. Admin may contact team member offline to follow up on related actions. `,
      },

      {
        header: `What is "All Members" section? `,
        content: `In all members sections, admins will be able to see all there individual team members as well as members they want to add in platform before adding them into team. This flexibility is provided to add a member in individual's account and make them available for upcoming events such as Practice, Games & Tournaments. Usually the members for whom we need to assess the performance & fitment into team need to added into this section. Addition of members into All Members section does not require there approval but they will be informed via email on addition into platform. `,
      },

      {
        header: `How can I identify members who are part of any team in the All Members section?`,
        content: `In the All Members section, members who are part of any team will be highlighted with a distinctive team icon next to their profile. This makes it easy for you to identify and connect with individuals who share your team affiliations.`,
      },

      {
        header: `How do I view all the common teams associated with a particular member?`,
        content: `By selecting an individual member in the All Members section, you can view all the teams they are associated with. The system displays a list of common teams, providing you with a comprehensive view of the member's team affiliations.`,
      },{
        header: `Can I explore the profiles of members within a specific team?`,
        content: `Absolutely! When you select a team, the related profiles of members within that particular team are displayed. This feature allows you to learn more about the individuals involved, fostering better team collaboration and communication.`,
      },
      
      {
        header: `How do I invite an existing member to join a new team?`,
        content: `To invite a member into a team, simply select the plus icon located at the right bottom corner of the screen. This action triggers a dropdown menu displaying all the teams you are part of. Choose the relevant team from the list, and send an invite to the member to join that specific team. It's a straightforward and efficient way to build and manage your teams on our platform.`,
      },

      {
        header: `How can I download the profiles of all team members in the Teams section?`,
        content: `To download the profiles of all team members, simply navigate to the Teams section and select the download icon located at the top of the member list within the specific team. This feature provides a convenient way to access comprehensive information about your team members.`,
      },

      {
        header: `What details are included in the downloaded file of team member profiles?`,
        content: `The downloaded file contains detailed information about each team member, including their individual sports introduction, jersey sizes, name and number on the jersey, and the expectations of team members from the team. It's a comprehensive resource that allows you to have a deeper understanding of your team's composition.`,
      },

      {
        header: `How does download feature benefit team management and communication?`,
        content: `The ability to download team member profiles streamlines team management and enhances communication. Having access to individual sports introductions, jersey details, and team expectations in one file facilitates efficient coordination, helping team leaders and members stay well-informed and connected.`,
      },

      {
        header: `Can I customize the information included in the downloaded profiles?`,
        content: `Currently, the download feature provides a standardized set of information for each team member, including sports introduction, jersey sizes, name and number on the jersey, and expectations. While customization options for the downloaded file may vary, this standardized format ensures a comprehensive overview of each team member.`,
      },

      {
        header: `Is the downloaded file secure and private?`,
        content: `es, the downloaded file is secure and private, accessible only to authorized team members. We prioritize the confidentiality and privacy of your team's information, ensuring that it remains within the designated team management space.`,
      },
    // Add more accordion items for createTeam option
  ];


//   Create team option 
  export  const createEventAccordionItems = [
    {
      header: `What are the different types of events that can be created in the platform?`,
      content: `In our platform, you can create three types of events: Practice, Game, and Tournament. Each serves a unique purpose and caters to different scenarios in the sports or activity scheduling process.`,
    },

    {
        header: `How is a Practice event different from other types?`,
        content: `Practice events are spontaneous and not bound by a predefined schedule. They can be organized within the same team, allowing members to book dedicated practice areas. Unlike other events, practices may not involve opponents and can be more flexible in nature.`,
      },

      {
        header: `What information is required when creating a Game event?`,
        content: `When creating a Game event, organizers need to specify opponents. This ensures that the event involves two teams playing against each other. Game events can be friendly matches played for fun or leisure.`,
      },

      {
        header: `Can you explain the process of creating a Tournament event?`,
        content: `Tournament events are part of a scheduled series of events communicated ahead of time. Organizers need to provide a Tournament Name and specify opponents. This type of event is typically organized in advance and follows a predefined structure.`,
      },


      {
        header: `What distinguishes an Admin-hosted event from a non-Admin hosted event?`,
        content: `Admins have the privilege of selecting specific team members or even non-team members when sending invites for an event. Non-Admins, on the other hand, can only send invites to the entire team, without the ability to pick individual members.`,
      },

      {
        header: `How does the scheduling system work for event invites?`,
        content: `When an invite is sent, a placeholder for the event is created in the scheduled section of each invited member. For example, if an invite is sent for Monday 6-8 pm to the whole team, that time slot in each member's schedule will be updated as a placeholder. Members receive notifications about the invite and must respond with a Yes or No.`,
      },

      {
        header: `What happens when a user responds with Yes to an event?`,
        content: `When a user responds with Yes to an event, the dotted line representing the event in their schedule turns into a solid line. Additionally, the related timeslot is reflected in the user's device calendar, providing a clear representation of confirmed events.`,
      },


      {
        header: `What privileges does an event organizer (Admin) have?`,
        content: `Event organizers, or Admins, have several privileges. They can send up to three reminders to users to respond to an event. They can mark other users who responded with a Yes as event admins. Admins have the exclusive ability to download profiles of users who have confirmed attendance. Additionally, they can record and manage expenses related to the event.`,
      },

      {
        header: `How does expense recording work for an event?`,
        content: `Admins can record expenses for an event by adding descriptions and specifying amounts. The currency used for the first expense sets the currency for all subsequent expenses. This ensures consistency in recording and tracking expenses for that specific event.`,
      },

      {
        header: `Explain the process of initiating a payment split.`,
        content: `After recording all expenses, an Admin can initiate a payment split within the accepted members of the event. This split can be done equally among all members or adjusted based on individual contributions. Admins also have the flexibility to add unplanned members before initiating a payment split.`,
      },

      {
        header: `What happens after the admin confirms the split amount?`,
        content: `Once the Admin confirms the split amount, a notification is triggered, and a highlighted section appears in each user's schedule. This section indicates the need for payment and ensures that users are aware of their financial responsibilities for the event.`,
      },

      {
        header: `How do users make payments and confirm them?`,
        content: `Users make offline payments to the payment initiator and capture a screenshot of the transaction. This screenshot can then be attached to the event for which the payment is due. Users send these details through the application to the payment initiator, who confirms the receipt of payments.`,
      },


      {
        header: `Can admins send payment reminders to users?`,
        content: `Yes, Admins have the option to send payment reminders to individual or multiple users. This feature helps ensure that users stay informed about pending payments and facilitates timely settlement.`,
      },

     
    // Add more accordion items for createEvent option
  ];
  
  export const userTrainingAccordionItems = [
    {
      header: `How can I search for sports training in my location?`,
      content: `To find sports training near you, navigate to the Sports Training module and use the search filters. You can filter results based on location, ratings, age group, distance, and proficiency. This ensures you discover training programs that align with your preferences and location. 
      
      You can easily change this by selecting filter option on the training listing screen. Training can be displayed in two ways, one is in listing format and the other one is in the map format. `,
    },
    
    {
        header: `What details can I view about a specific training?`,
        content: `Upon selecting a training program, you gain access to comprehensive information. This includes the curriculum, training location, duration, proficiency level catered to, age group suitability, session duration, minimum sessions required, price per session, and details about the trainers conducting the training. Additionally, you can explore the amenities provided by the facility, ongoing promotions, and past ratings given by other users who participated in the same training.`,
      },
      
      {
        header: `How can I check the availability of a specific training program?`,
        content: `After selecting a training program, you can check its availability. The platform presents individual training slots organized by days in a week. You have the flexibility to choose the start date, preferred timeslot, and select the number of training slots you wish to attend.`,
      },
      
      {
        header: `How is the total cost calculated for my selected training slots?`,
        content: `The total cost is calculated based on the number of training slots you've selected and the cost per slot. Additionally, platform fees are factored into the final payment. Once you confirm the payment, a unique Confirmation ID is generated, providing a seamless and transparent process for users.`,
      },
      
      {
        header: `Where can I view my scheduled training slots?`,
        content: `Your scheduled training slots are conveniently displayed in the schedule section of the application. Each individual training slot is associated with a unique QR code. This code must be presented to the coach or facility manager during each training session to mark your attendance accurately.`,
      },
      
      {
        header: `How is attendance tracked during training sessions?`,
        content: `Coaches and facility managers can efficiently track attendance by scanning the unique QR code associated with each training slot. This automated process ensures precise attendance records for every specified training session.`,
      },
      
      {
        header: `How is user progress evaluated during the training?`,
        content: `Coaches and facility managers evaluate user progress based on four distinct stages: Beginner (learning skills, requiring more practice and focus), Advanced (following rules step-by-step and applying them), Proficient (learning new techniques and implementing them), and Achieved this level with excellence. Users can request evaluations, and progress is monitored throughout the training period.`,
      },
      
      {
        header: `Can I share my previous evaluation with a new trainer or facility?`,
        content: `Yes, users have the option to share their previous evaluation with a new trainer or facility during the booking process. This ensures continuity and provides valuable insights into the user's sports proficiency. `,
      },
      
      {
        header: `How do I provide feedback for the facility, coaches, and training sessions?`,
        content: `After completing all training slots, you can provide feedback for the facility, coaches, and individual training sessions. If there are multiple coaches, the platform allows you to submit feedback for each coach separately. This feature fosters a user-centric environment, encouraging constructive communication and continuous improvement in the training programs offered.`,
      },
      
      {
        header: `What happens if I book a training without selecting "Share Previous Evaluation"?`,
        content: `If you book a training without selecting "Share Previous Evaluation," the coach or facility manager  will not have access to your   
        
        previous evaluation provided at different training facilities
        
        on the platform. The evaluation provided for same facility and for same sports type will still be visible to Facility Manager and Coach.
        
        In such cases, users are advised to share these details offline with the coach and facility managers to ensure they have comprehensive insights into your sports proficiency.`,
      },
      
      {
        header: `How is each timeslot organized and displayed in the schedule section?`,
        content: `Each timeslot is summarized based on the day of the week and the selected timeslot for that particular day. For instance, all Monday 6-9 pm slots will be displayed together in the related details of the Monday 6-8 pm slots. This organization ensures clarity and ease of access when reviewing your training schedule.`,
      },
      
      {
        header: `Can I view all my training dates in one place?`,
        content: `Yes, you can choose to view all your training dates in the Training section, organized by family member. The family member section is available in the Create Team module of the application. This section provides a comprehensive overview of  training schedule for user and his family members, allowing one to plan and manage your sports activities efficiently.`,
      },
      
      {
        header: `Can I book training for family members as well?`,
        content: `Absolutely, users have the option to book training not only for themselves but also for their family members. This feature enhances the flexibility and convenience of managing sports activities for the entire family within the application. User may chose to add Family member ahead of booking training in Create Team section of the application or it can be accessed during Training Booking time as well. Platform provides this flexibility to enhance user experience.`,
      },

      {
        header: `How can I view the training schedule for a specific user in the Schedule section?`,
        content: `In the Schedule section, there is a provision to view training schedules for specified users. You can easily navigate and select the user for whom you want to view the training schedule, providing a tailored and user-friendly experience.`,
      },

      
      
                            
  ];